import * as React from "react";
import { RouteComponentProps } from "@reach/router";

export const Introduction = (props: IntroductionProps) => {
  return <div>Introduction works!</div>;
};

type IntroductionProps = RouteComponentProps;
